import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './Icon';
import './Navbar.css';

const Navbar = ({ 
  title = '', 
  showBack = true, 
  showHome = true,
  onBack,
  onHome,
  className = ''
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  const handleHome = () => {
    if (onHome) {
      onHome();
    } else {
      navigate('/home');
    }
  };

  return (
    <nav className={`navbar ${className}`}>
      <div className="nav-content">
        {showBack && (
          <div className="nav-back" onClick={handleBack}>
            <Icon type="fanhui3" />
          </div>
        )}
        <div className="nav-title">{title}</div>
        {showHome && (
          <div className="nav-home" onClick={handleHome}>
            <Icon type="shouye8" />
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
